<template>
  <div v-show="mutableShow" class="xm-gallery" @click="hide">
    <span class="xm-gallery-img"
          :style="{backgroundImage: 'url(' + src + ')'}"></span>
    <div class="xm-gallery-opr">
      <span class="xm-gallery-del">
        <i class="icon iconfont xm-icon-gallery-delete" @click="deleteImage">&#xe605;</i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'xm-gallery',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    src: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      mutableShow: this.show
    };
  },
  methods: {
    deleteImage() {
      this.$emit('delete', this);
    },
    hide() {
      this.mutableShow = false;
      this.$emit('close', this);
    },
  },
  watch: {
    show(val) {
      this.mutableShow = val;
    }
  }
};
</script>

<style lang="less" scoped>

@galleryOprHeight: 1.2rem;
.xm-gallery {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000000;
    z-index: 1000;
}
.xm-gallery-img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: @galleryOprHeight;
    left: 0;
    background: center center no-repeat;
    background-size: contain;
    z-index: 100;
}
.xm-gallery-opr {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #0D0D0D;
    color: #FFFFFF;
    line-height: @galleryOprHeight;
    text-align: center;
}
.xm-gallery-del {
    display: block;
}

.xm-icon-gallery-delete {
  color: white;
  font-size: 0.4rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue